<template>
  <SrpModal v-model:isVisible="_isVisible" :isClosable="false">
    <template #content>
      <div v-if="bookDemoSubmitReturnPayload?.isShowCreatorMsg" class="well-get-in-touch-msg-5a50c">
        <div class="global-h1 well-get-in-touch-msg-5a50c__title">
          <div class="well-get-in-touch-msg-5a50c__check-circle">
            <IconEmbedded name="check_4" :size="20" />
          </div>
          We'll get in touch shortly!
        </div>
        <div class="well-get-in-touch-msg-5a50c__counter">This screen will close in {{ countdownNumber }}<EllipsisAnimated /></div>
      </div>

      <!-- "Request a demo" form -->
      <div
        v-else
        :class="{
          'request-a-demo-form-8b3a7': true,
          'request-a-demo-form-8b3a7--disabled': isSendingRequest || isLoadingOrgTypes,
        }"
      >
        <div class="standard-page-header request-a-demo-form-8b3a7__header">
          <div class="global-h1 standard-page-header__title">Schedule a Demo</div>
          <div class="standard-page-header__subtitle">See how your destination can gain the edge in their UGC strategy!</div>
        </div>

        <div class="request-a-demo-form-8b3a7__form-itself">
          <!-- Title and form element -->
          <div class="title-and-form-element-e67b3 request-a-demo-form-8b3a7__title-and-form-element request-a-demo-form-8b3a7__title-and-form-element--full-width">
            <div class="global-h4 title-and-form-element-e67b3__title">Which best describes your organization? <span class="title-and-form-element-e67b3__title-gray-text">(required)</span></div>

            <span class="global-select-wrap title-and-form-element-e67b3__form-element title-and-form-element-e67b3__form-element--half-width">
              <select class="global-select" v-model="formData.organizationType" @focus="isValidationErrorVisible = false">
                <option selected disabled :value="null">Choose an option</option>
                <option v-for="orgType in orgTypes" :key="orgType" :value="orgType">
                  {{ orgType }}
                </option>
              </select>
              <span class="global-select-wrap__arrow">&nbsp;</span>
            </span>
          </div>
          <!-- / Title and form element -->

          <!--<div class="request-a-demo-form-8b3a7__divider"></div>-->

          <!-- Title and form element -->
          <div class="title-and-form-element-e67b3 request-a-demo-form-8b3a7__title-and-form-element">
            <div class="global-h4 title-and-form-element-e67b3__title">Email <span class="title-and-form-element-e67b3__title-gray-text">(required)</span></div>

            <input class="global-text-input title-and-form-element-e67b3__form-element" type="email" placeholder="me@example.com" v-model="formData.email" @focus="isValidationErrorVisible = false" />
          </div>
          <!-- / Title and form element -->

          <div class="request-a-demo-form-8b3a7__divider"></div>

          <!-- Title and form element -->
          <div class="title-and-form-element-e67b3 request-a-demo-form-8b3a7__title-and-form-element">
            <div class="global-h4 title-and-form-element-e67b3__title">First Name</div>

            <input
              class="global-text-input title-and-form-element-e67b3__form-element"
              type="text"
              placeholder="John"
              v-model="formData.firstName"
              @focus="isValidationErrorVisible = false"
              maxlength="50"
              autocomplete="given-name"
            />
          </div>
          <!-- / Title and form element -->

          <!-- Title and form element -->
          <div class="title-and-form-element-e67b3 request-a-demo-form-8b3a7__title-and-form-element">
            <div class="global-h4 title-and-form-element-e67b3__title">Last Name</div>

            <input
              class="global-text-input title-and-form-element-e67b3__form-element"
              type="text"
              placeholder="Smith"
              v-model="formData.lastName"
              @focus="isValidationErrorVisible = false"
              maxlength="50"
              autocomplete="family-name"
            />
          </div>
          <!-- / Title and form element -->

          <!-- Title and form element -->
          <div class="title-and-form-element-e67b3 request-a-demo-form-8b3a7__title-and-form-element">
            <div class="global-h4 title-and-form-element-e67b3__title">Company Name</div>

            <input class="global-text-input title-and-form-element-e67b3__form-element" type="text" v-model="formData.companyName" @focus="isValidationErrorVisible = false" />
          </div>
          <!-- / Title and form element -->

          <!-- Title and form element -->
          <div class="title-and-form-element-e67b3 request-a-demo-form-8b3a7__title-and-form-element">
            <div class="global-h4 title-and-form-element-e67b3__title">State/Region</div>

            <input
              class="global-text-input title-and-form-element-e67b3__form-element"
              type="text"
              placeholder="MN"
              v-model="formData.stateOrRegion"
              @focus="isValidationErrorVisible = false"
              maxlength="50"
              autocomplete="region"
            />
          </div>
          <!-- / Title and form element -->

          <!-- Title and form element -->
          <div class="title-and-form-element-e67b3 request-a-demo-form-8b3a7__title-and-form-element">
            <div class="global-h4 title-and-form-element-e67b3__title">Phone Number</div>

            <input
              class="global-text-input title-and-form-element-e67b3__form-element"
              placeholder="+1"
              v-maska:[maskOptions]="maskDetails"
              type="tel"
              v-model="formData.phoneNumber"
              @focus="isValidationErrorVisible = false"
            />
          </div>
          <!-- / Title and form element -->
        </div>
      </div>
      <!-- / "Request a demo" form -->
    </template>

    <template v-if="!bookDemoSubmitReturnPayload?.isShowCreatorMsg" #footer>
      <div v-if="isValidationErrorVisible" class="global-error-string" style="margin-right: 12px">Please specify your email and org type.</div>

      <SrpButton color="orange" @click="sendRequest" :isDisabled="isSendingRequest">
        <template v-if="isSendingRequest" #icon><LoadingIcon :size="22" /></template>
        Book a Demo
      </SrpButton>
    </template>
  </SrpModal>
</template>

<script setup lang="ts">
import { ref, nextTick, watch } from "vue";
import RequestADemoRepo from "@repos/RequestADemoRepo";
import { countdown } from "@logic/Miscellaneous";
import { emailValidationRegExps } from "@helpers/EmailHelper";

// Components
import SrpModal from "@components/ui/SrpModal.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import LoadingIcon from "@components/ui/LoadingIcon.vue";
import EllipsisAnimated from "@components/ui/EllipsisAnimated.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";

// Types
import { MaskaDetail, MaskOptions, vMaska } from "maska";
import { RequestADemoFormData } from "@contracts/requestADemoForm";
import { BookDemoSubmitReturnType } from "@contracts/requestADemoForm";
import { MetricSender } from "@/helpers/MetricSender";

// Is Visible =================================================================
const _isVisible = ref<boolean>(false);

// Phone number ===============================================================
const maskDetails = ref<MaskaDetail>({ completed: false, masked: "", unmasked: "" });
const maskOptions = ref<MaskOptions>({
  mask: "+1 (###) ###-####",
});

// Get all organization types =================================================
const isLoadingOrgTypes = ref<boolean>(true);
const orgTypes = ref<Array<string>>([]);

async function getAllOrgTypes() {
  isLoadingOrgTypes.value = true;
  orgTypes.value = await RequestADemoRepo.getAllOrganizationTypes();
  isLoadingOrgTypes.value = false;
}

watch(_isVisible, () => {
  if (_isVisible.value && !orgTypes.value.length) {
    getAllOrgTypes();
  }
  if (_isVisible.value) {
    MetricSender.sendMetric("demo_opened", null);
  }
});

// Send request ===============================================================
const formData = ref<RequestADemoFormData>({
  organizationType: null,
  email: "",
  firstName: "",
  lastName: "",
  companyName: "",
  stateOrRegion: "",
  phoneNumber: "",
});

function clearForm() {
  formData.value = {
    organizationType: null,
    email: "",
    firstName: "",
    lastName: "",
    companyName: "",
    stateOrRegion: "",
    phoneNumber: "",
  };
}

const isSendingRequest = ref<boolean>(false);
const bookDemoSubmitReturnPayload = ref<BookDemoSubmitReturnType | null>(null);
const countdownNumber = ref<number>(0);

const isValidationErrorVisible = ref<boolean>(false);

let countdownAbort = null;

async function sendRequest() {
  isValidationErrorVisible.value = !validateForm();
  if (isValidationErrorVisible.value) {
    return;
  }

  MetricSender.sendMetric("demo_requested", { orgType: formData.value.organizationType });
  isSendingRequest.value = true;
  bookDemoSubmitReturnPayload.value = await RequestADemoRepo.requestADemo(formData.value);

  if (bookDemoSubmitReturnPayload.value?.redirectLink) {
    window.location.href = bookDemoSubmitReturnPayload.value?.redirectLink;
  } else {
    isSendingRequest.value = false; // Only set for creators (since we're redirecting for customers)
    countdownAbort = countdown(async howManySecondsLeft => {
      countdownNumber.value = howManySecondsLeft;

      if (howManySecondsLeft === 0) {
        _isVisible.value = false;

        await nextTick();
        bookDemoSubmitReturnPayload.value = null;
      }
    }, 5);
    clearForm();
  }
}

watch(_isVisible, () => {
  countdownAbort?.();
  bookDemoSubmitReturnPayload.value = null;
});

// Validate form ==============================================================
function validateForm(): boolean {
  let isFormValid = true;

  Object.keys(formData.value).forEach(key => {
    if (key === "email" && !emailValidationRegExps.forgiving.test(formData.value.email)) {
      isFormValid = false;
    } else if (key === "organizationType" && !formData.value[key]) {
      isFormValid = false;
    }
  });

  return isFormValid;
}

// Define expose ==============================================================
defineExpose({
  openModal: () => (_isVisible.value = true),
});
</script>

<style lang="scss">
@import "@/scss/screen-size-ranges.scss";

// Title and form element =====================================================
.title-and-form-element-e67b3 {
  &__title {
    margin-bottom: 8px;
    font-weight: 600;
  }

  &__title-gray-text {
    color: #8a8a8a;
    font-weight: 400;
  }

  &__form-element {
    &--half-width {
      width: calc(50% - 15px);
    }
  }
}
// desktop wide -----------------------
@media (min-width: $desktop-wide-min-width) {
}
// desktop ----------------------------
@media (min-width: $desktop-min-width) and (max-width: $desktop-max-width) {
}
// laptop -----------------------------
@media (min-width: $laptop-min-width) and (max-width: $laptop-max-width) {
}
// tablet large -----------------------
@media (min-width: $tablet-large-min-width) and (max-width: $tablet-large-max-width) {
}
// tablet -----------------------------
@media (min-width: $tablet-min-width) and (max-width: $tablet-max-width) {
}
// mobile -----------------------------
@media (max-width: $mobile-max-width) {
  .title-and-form-element-e67b3 {
    &__form-element {
      &--half-width {
        width: 100%;
      }
    }
  }
}

// "Request a demo" form ======================================================
.request-a-demo-form-8b3a7 {
  &--disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &__header {
    margin-bottom: 25px;
  }

  &__form-itself {
    gap: 25px 30px;
    display: flex;
    flex-wrap: wrap;
  }

  &__title-and-form-element {
    width: calc(50% - 15px);

    &--full-width {
      width: 100%;
    }
  }

  &__divider {
    width: 100%;
    border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
  }
}
// desktop wide -----------------------
@media (min-width: $desktop-wide-min-width) {
}
// desktop ----------------------------
@media (min-width: $desktop-min-width) and (max-width: $desktop-max-width) {
}
// laptop -----------------------------
@media (min-width: $laptop-min-width) and (max-width: $laptop-max-width) {
}
// tablet large -----------------------
@media (min-width: $tablet-large-min-width) and (max-width: $tablet-large-max-width) {
}
// tablet -----------------------------
@media (min-width: $tablet-min-width) and (max-width: $tablet-max-width) {
}
// mobile -----------------------------
@media (max-width: $mobile-max-width) {
  .request-a-demo-form-8b3a7 {
    &__title-and-form-element {
      width: 100%;

      &--full-width {
        width: 100%;
      }
    }
  }
}

// "We'll get in touch shortly" message =======================================
.well-get-in-touch-msg-5a50c {
  padding: 40px 20px;

  &__check-circle {
    width: 38px;
    min-width: 38px;
    margin-right: 8px;
    height: 38px;
    box-sizing: border-box;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    top: 2px;
    background: #dcf5d6;

    :deep(svg) {
      fill: #518345;
    }
  }

  &__title {
    margin-bottom: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    text-align: center;
  }

  &__counter {
    font-style: italic;
    text-align: center;
  }
}
</style>
